var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Islamic Org"}},[_c('v-select',{attrs:{"id":"Islamic Org","value":_vm.inpoId,"options":_vm.entities,"reduce":function (tag) { return tag.id; },"label":"name","disabled":_vm.isDisabled},on:{"input":_vm.setInpoID},scopedSlots:_vm._u([{key:"search",fn:function(ref){
var attributes = ref.attributes;
var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search"},'input',attributes,false),events))]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }